import { ChevronLeft, Edit, Pencil, PencilIcon } from "lucide-react";
import { Button } from "../input/button";

import * as React from "react";
import { pageHeaderStyleDriver } from "@/utils/componentStyle";
import { Logo } from "../information/brand-logo";
import { Text } from "../information/text";

interface PageHeaderProps {
  title: string;
  logo?: React.ReactNode;
  showLogo?: boolean;
  onBack?: () => void;
  onEdit?: () => void;
  rightButtons?: React.ReactNode | React.ReactNode[];
}

export function PageHeader({
  title,
  logo,
  showLogo,
  onBack,
  onEdit,
  rightButtons,
}: PageHeaderProps) {
  return (
    <div className={pageHeaderStyleDriver.root}>
      <div className={pageHeaderStyleDriver.left}>
        {showLogo && logo}
        {onBack && (
          <Button
            size="sm"
            onClick={onBack}
            variant="text"
            className={pageHeaderStyleDriver.iconButton}
          >
            <ChevronLeft className="h-4 w-4" />
          </Button>
        )}
        <div className="flex items-center space-x-2">
          <Text as="h1" className={pageHeaderStyleDriver.title}>{title}</Text>
          {onEdit && (
            <Button
              size="sm"
              variant="text"
              onClick={onEdit}
              className={pageHeaderStyleDriver.iconButton}
            >
              <PencilIcon className="h-4 w-4" />
            </Button>
          )}
        </div>
      </div>
      <div className={pageHeaderStyleDriver.right}>
        {Array.isArray(rightButtons)
          ? rightButtons.map((child, idx) =>
              React.isValidElement(child)
                ? React.cloneElement(child, { key: child.key ?? `right-button-${idx}` })
                : <React.Fragment key={`right-button-${idx}`}>{child}</React.Fragment>
            )
          : rightButtons}
      </div>
    </div>
  );
}

export const PageHeaderDemo = () => {
  return (
    <PageHeader
      title="Dashboard"
      logo={<Logo />}
      onBack={() => window.history.back()}
      onEdit={() => console.log("Edit")}
      rightButtons={[
        <Button key="save" variant="outline">
          <Text as="p">Save</Text>
        </Button>,
        <Button key="delete">
          <Text as="p">Delete</Text>
        </Button>,
      ]}
    />
  );
};
